<template>
  <nav class="desktop-nav">
    <span class="desktop-nav__links" v-if="!checkIfAdminPage($route)">
      <a
        :key="i"
        v-for="(link, i) in links"
        :href="link.to"
        class="link link--grey"
      >
        {{ link.label }}
      </a>
    </span>

    <!-- Links for admin page -->
    <span class="desktop-nav__links" v-if="adminOnAdminPage($route)">
      <span
        :key="i"
        v-for="(admin_link, i) in admin_links"
        @click="setAdminView(admin_link.admin_view)"
        class="link link--grey"
      >
        {{ admin_link.label }}
      </span>
    </span>
  </nav>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DesktopNav',
  props: [ 'user' ],
  data() {
    return {
      links: [
        // { label: 'Hjärnorna bakom', to: 'https://pensionondemand.se/hjarnorna-bakom' },
        { label: 'Om Pension on Demand', to: 'https://pensionondemand.se/om-oss' },
      ],
      admin_links: [
        { label: 'Databasvy', admin_view: 'dataCollection' },
        { label: 'Min profil', admin_view: 'settings' },
      ]
    }
  },
  methods: {
    ...mapMutations(['setAdminView']),
    checkIfAdminPage (route) {
      return route.path == '/admin-page'
    },
    adminOnAdminPage (route) {
      return this.checkIfAdminPage(route) && this.user.role == 'admin'
    }
  },
}
</script>

<style lang="scss" scoped>
.desktop-nav {
  display: none;

  @include breakpoints(xLarge) {
    display: block;

    &__links {
      display: flex;

      > a:first-of-type, > span:first-of-type {
        margin-right: 3rem;
      }
    }

    &__link {
      display: block;
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      color: rgba(88, 88, 88, 0.9);
      text-transform: uppercase;
      transition: color .2s;

      &:hover {
        cursor: pointer; // For admin links
        border-bottom: 1px solid rgba(88, 88, 88, 0.9);
      }
    }

    a:first-of-type {
      margin-right: 2rem;
    }
  }
}
</style>
